export default __webpack_public_path__ + "static/media/GithubFinder.96d83169.png";